module.exports = __webpack_public_path__ + "static/makkara_4-058986ad0971565746cf7d6e16dbfd94.jpg";